// Currently not being used, but ready to go
import { combineReducers } from 'redux';
import options from './options';
import dev from './dev';
import modalState from './modalState';
import location from './location';

export default combineReducers({ dev, options, modalState, location });
